import { Button } from '@shinetools/lumen-react'
import { SettingsIcon } from 'lucide-react'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { BillsListHeaderActionCreatePurchase } from './elements/BillsListHeaderActionCreatePurchase'

export const BillsListHeaderActions = (): ReactElement => {
  const navigate = useNavigate()
  const { url: billsSettingsUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getSettingsRoute())

  const handleSettingsClick = () => {
    if (billsSettingsUrl) {
      navigate(billsSettingsUrl)
    }
  }

  return (
    <>
      <Button icon={<SettingsIcon />} variant="outlined" onClick={handleSettingsClick} />

      <BillsListHeaderActionCreatePurchase />
    </>
  )
}
